import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "alert alert-warning text-dark",
  role: "alert"
}
const _hoisted_11 = {
  key: 0,
  class: "card mt-3"
}
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "list-group list-group-flush" }
const _hoisted_14 = { class: "text-primary" }
const _hoisted_15 = {
  key: 1,
  class: "card mt-3"
}
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = { class: "list-group list-group-flush" }
const _hoisted_18 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_19 = {
  key: 2,
  class: "card mt-3"
}
const _hoisted_20 = { class: "card-header" }
const _hoisted_21 = { class: "list-group list-group-flush" }
const _hoisted_22 = {
  class: "text-primary",
  target: "_blank"
}
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = {
  key: 3,
  class: "card mt-3"
}
const _hoisted_25 = { class: "card-header" }
const _hoisted_26 = { class: "list-group list-group-flush" }
const _hoisted_27 = {
  key: 4,
  class: "card mt-3"
}
const _hoisted_28 = { class: "card-header" }
const _hoisted_29 = { class: "list-group list-group-flush" }
const _hoisted_30 = {
  key: 5,
  class: "card mt-3"
}
const _hoisted_31 = { class: "card-header" }
const _hoisted_32 = { class: "list-group list-group-flush" }
const _hoisted_33 = {
  key: 6,
  class: "card mt-3"
}
const _hoisted_34 = { class: "card-header" }
const _hoisted_35 = { class: "list-group list-group-flush" }
const _hoisted_36 = {
  key: 7,
  class: "card mt-3"
}
const _hoisted_37 = { class: "card-header" }
const _hoisted_38 = { class: "list-group list-group-flush" }

import { computed, toRef } from 'vue'
    import type { AttributeDependenciesDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDependenciesDialog'
    import type { DependentEntityInfo } from '@common/types'
    import { dynamicUiRoutes } from '@common/dynamicUiRoutes'
    import { useRoute } from 'vue-router'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AttributeDependenciesDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- router ----------------

    const route = useRoute()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const rm = computed(() => vm.value.rm)

    // ---------------- url helpers ----------------

    function url_MeasurementsPage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Criteria_MeasurementsPage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            e.EvalModelId,
            e.ScoringEnabled
        )
    }

    function url_EditFormPage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Alternatives_EditFormPage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            Number.parseInt(e.Id)
        )
    }

    function url_ReportViewPage(e: DependentEntityInfo): string
    {
        return dynamicUiRoutes.Reports_ReportViewPage(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            e.Id
        )
    }

    // ---------------- methods ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, "Attribute dependencies: " + _toDisplayString(vm.value.attributeName), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (!rm.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Checking dependencies...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (rm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", null, [
                          _cache[1] || (_cache[1] = _createTextVNode("The attribute '", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(rm.value.Name), 1 /* TEXT */),
                          _cache[2] || (_cache[2] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(rm.value.Count), 1 /* TEXT */),
                          _cache[3] || (_cache[3] = _createTextVNode(" places.", -1 /* CACHED */))
                        ])
                      ]),
                      (rm.value.Forms.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, " Forms (" + _toDisplayString(rm.value.Forms.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Forms, (f) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: f.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [
                                    _createTextVNode(_toDisplayString(f.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_EditFormPage(f)]
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.Reports.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, " Reports (" + _toDisplayString(rm.value.Reports.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Reports, (r) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: r.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, [
                                    _createTextVNode(_toDisplayString(r.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_ReportViewPage(r)]
                                  ])
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.Criteria.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, " Criteria (" + _toDisplayString(rm.value.Criteria.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Criteria, (c) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: c.Id
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_22, [
                                    _createTextVNode(_toDisplayString(c.Name), 1 /* TEXT */)
                                  ])), [
                                    [_directive_sanitizedHref, url_MeasurementsPage(c)]
                                  ]),
                                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", _hoisted_23, _toDisplayString(c.Path), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.Lists.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, " Lists (" + _toDisplayString(rm.value.Lists.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Lists, (l) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: l.Id
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(l.Name), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.CalcAttributes.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, " Calculated attributes (" + _toDisplayString(rm.value.CalcAttributes.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.CalcAttributes, (attr) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: attr.Id
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(attr.Name), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.Notifications.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, " Notifications (" + _toDisplayString(rm.value.Notifications.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_32, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Notifications, (n) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: n.Id
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(n.Name), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.ScoringSurveys.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, " Scoring (" + _toDisplayString(rm.value.ScoringSurveys.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_35, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.ScoringSurveys, (s) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: s.Id
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(s.Name), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      (rm.value.EstimationsSurveys.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, " Assessments (" + _toDisplayString(rm.value.EstimationsSurveys.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.EstimationsSurveys, (s) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "list-group-item",
                                  key: s.Id
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(s.Name), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})